import { useParamsSearch } from '@anytag/shared-hooks';
import { TrendingPostsFilterSearchSchemaType } from '../schemaTypes';

export const useTrendingPostsFilter = () => useParamsSearch<TrendingPostsFilterSearchSchemaType>();
